import React from "react";

export type TGoogleIconProps = React.SVGAttributes<SVGElement>;

export function GoogleIcon({ ...rest }: TGoogleIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M30.08 16.3334C30.08 15.2934 29.9867 14.2934 29.8133 13.3334H16V19.0134H23.8933C23.5467 20.84 22.5067 
          22.3867 20.9467 23.4267V27.12H25.7067C28.48 24.56 30.08 20.8 30.08 16.3334Z"
        fill="#4285F4"
      />
      <path
        d="M16 30.6667C19.96 30.6667 23.28 29.36 25.7067 27.12L20.9467 23.4267C19.64 24.3067 17.9733 24.84 16 
          24.84C12.1867 24.84 8.94667 22.2667 7.78667 18.8H2.90667V22.5867C5.32 27.3734 10.2667 30.6667 16 30.6667Z"
        fill="#34A853"
      />
      <path
        d="M7.78667 18.7866C7.49334 17.9066 7.32 16.9733 7.32 16C7.32 15.0266 7.49334 14.0933 7.78667 
          13.2133V9.42664H2.90667C1.90667 11.4 1.33334 13.6266 1.33334 16C1.33334 18.3733 1.90667 20.6 2.90667 
          22.5733L6.70667 19.6133L7.78667 18.7866Z"
        fill="#FBBC05"
      />
      <path
        d="M16 7.17337C18.16 7.17337 20.08 7.92004 21.6133 9.36004L25.8133 5.16004C23.2667 2.78671 19.96 1.33337 
          16 1.33337C10.2667 1.33337 5.32 4.62671 2.90667 9.42671L7.78667 13.2134C8.94667 9.74671 12.1867 7.17337 
          16 7.17337Z"
        fill="#EA4335"
      />
    </svg>
  );
}
